import { render } from "./Index.vue?vue&type=template&id=a5c9cbae"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/DisabilitiesTypes/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a5c9cbae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a5c9cbae', __exports__)) {
    console.log('reload')
    api.reload('a5c9cbae', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=a5c9cbae", () => {
    console.log('re-render')
    api.rerender('a5c9cbae', render)
  })

}


export default __exports__